module.exports = __webpack_public_path__ + "static/lore_logo_text.3be3528b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/lore_logo_text.png
// module id = 272
// module chunks = 114276838955818